import { render } from "./pie.vue?vue&type=template&id=f6ef6230&scoped=true"
import script from "./pie.vue?vue&type=script&lang=js"
export * from "./pie.vue?vue&type=script&lang=js"

import "./pie.vue?vue&type=style&index=0&id=f6ef6230&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ef6230"]])

export default __exports__